module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pageTitle":"Dyson Sphere","description":""},"fi":{"pageTitle":"Dyson Sphere","description":""}}')
  delete Component.options._Ctor
}
